import { isPlpBrowseDataResults, isPlpSearchDataResults } from './typeHelpers';
import { getPageType } from './requestConfigsHelpers';
export function getProductCardCnstrcDataAttributes(productInfo) {
    let dataCnstrc = {};
    const { itemId, itemPrice, itemName, variationId } = productInfo;
    dataCnstrc = {
        'data-cnstrc-item-id': itemId,
        'data-cnstrc-item-name': itemName,
        'data-cnstrc-item-price': itemPrice,
        'data-cnstrc-item-variation-id': variationId,
    };
    return dataCnstrc;
}
export function getPlpContainerCnstrcDataAttributes(data, requestConfigs) {
    if (!data || (!isPlpSearchDataResults(data) && !isPlpBrowseDataResults(data)))
        return {};
    const { filterName, filterValue } = requestConfigs;
    const pageType = getPageType(requestConfigs);
    let dataCnstrc = {};
    switch (pageType) {
        case 'browse':
            dataCnstrc = {
                'data-cnstrc-browse': true,
                'data-cnstrc-num-results': data.response.totalNumResults,
                'data-cnstrc-result-id': data.resultId,
                'data-cnstrc-filter-name': filterName,
                'data-cnstrc-filter-value': filterValue,
            };
            break;
        case 'search':
            dataCnstrc = {
                'data-cnstrc-search': true,
                'data-cnstrc-result-id': data.resultId,
                'data-cnstrc-num-results': data.response.totalNumResults,
            };
            break;
        case 'unknown':
            dataCnstrc = {};
            break;
        default:
            break;
    }
    return dataCnstrc;
}
